var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useState } from 'react';
import './recentChanges.css';
import { UuiFlexlayout } from '@aonunited/react';
import { columns } from './columnHeader/columnHeader';
import RecentChangesFilterPanel from './filterPanel/filterPanel';
import { useAppInfoStore, useErrorStore, useRecentChangesStore } from '../../store';
import { observer } from 'mobx-react';
import getRecentChangesData from '../../api/recentChanges';
import AonAgGridTable from '../../components/core/AonAgGridTable/table';
import { useNavigate } from 'react-router-dom';
var RecentChanges = (observer(function () {
    var appInfo = useAppInfoStore();
    var _a = React.useState({
        sortColumn: "", // no default shorting needed
        sortBy: "DESC"
    }), pageConfig = _a[0], setPageConfig = _a[1];
    var recentChangesStore = useRecentChangesStore();
    var _b = recentChangesStore.filterpanelStates, marketId = _b.marketId, country = _b.country, month = _b.month, region = _b.region;
    var _c = useState(false), isLoading = _c[0], setIsLoading = _c[1];
    var navigation = useNavigate();
    var _d = useState([]), RecentChangesData = _d[0], setRecentChangesData = _d[1];
    var _e = useState(window.innerHeight), currentInneHeight = _e[0], setcurrentInneHeight = _e[1];
    var errorStore = useErrorStore();
    useEffect(function () {
        fetchdata();
    }, []);
    useEffect(function () {
        var updateSize = function () {
            var innerHeight = window.innerHeight;
            setcurrentInneHeight(innerHeight);
        };
        window.addEventListener("resize", updateSize);
        return function () {
            window.removeEventListener("resize", updateSize);
        };
    }, []);
    var getMarketIds = function () {
        var _a;
        var _ids = [];
        if (marketId) {
            (_a = appInfo.marketType) === null || _a === void 0 ? void 0 : _a.forEach(function (item) {
                if (marketId.includes(item.marketTypeCategoryDesc)) {
                    _ids.push(item.marketTypeId);
                }
            });
        }
        return _ids.length ? _ids.join(",") : undefined;
    };
    var fetchdata = function () { return __awaiter(void 0, void 0, void 0, function () {
        var allCountries, params, response, error_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setIsLoading(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 4, 5]);
                    allCountries = (country === null || country === void 0 ? void 0 : country.length) && (country === null || country === void 0 ? void 0 : country.length) > 0 ? country === null || country === void 0 ? void 0 : country.join(",") : (_a = appInfo.country) === null || _a === void 0 ? void 0 : _a.filter(function (cn) { return region === null || region === void 0 ? void 0 : region.includes(cn.regionId.toString()); }).map(function (id) { return id.countryId; }).join(",");
                    params = { MarketTypeIds: getMarketIds(), fromDurationMonth: month, CountryIds: allCountries };
                    return [4 /*yield*/, getRecentChangesData(params)];
                case 2:
                    response = _b.sent();
                    setRecentChangesData(response.data);
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _b.sent();
                    console.log(error_1);
                    errorStore.showError({ message: "Server Error", code: "500" });
                    navigation('/error');
                    return [3 /*break*/, 5];
                case 4:
                    setIsLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var onHeaderClick = function (headerKey) {
        var revertSortBy = function (sBy) { return sBy === "DESC" ? "ASC" : "DESC"; };
        var tempData = __spreadArray([], RecentChangesData, true);
        var reverseSort = revertSortBy(pageConfig.sortBy);
        tempData = tempData.sort(function (a, b) {
            if (typeof a[headerKey] === "string" && typeof b[headerKey] === "string") {
                var value1 = a[headerKey].toLocaleLowerCase();
                var value2 = b[headerKey].toLocaleLowerCase();
                if (value1 < value2) {
                    return reverseSort === "ASC" ? -1 : +1;
                }
                else if (value1 > value2) {
                    return reverseSort === "ASC" ? +1 : -1;
                }
                else
                    return 0;
            }
            else {
                if (a[headerKey] < b[headerKey]) {
                    return reverseSort === "ASC" ? -1 : +1;
                }
                else if (a[headerKey] > b[headerKey]) {
                    return reverseSort === "ASC" ? +1 : -1;
                }
                else
                    return 0;
            }
        });
        setRecentChangesData(__spreadArray([], tempData, true));
        setPageConfig((function (prev) { return (__assign(__assign({}, prev), { sortBy: reverseSort, sortColumn: headerKey })); }));
    };
    var getRowStyle = function (params) {
        if (params.node.rowIndex % 4 === 0) {
            return { background: '#ececec' }; // Light grey background
        }
    };
    return (React.createElement(UuiFlexlayout, { direction: 'column', className: 'ratings-outer-container' },
        React.createElement("div", { className: 'ratings-title' }, "RECENT CHANGES"),
        React.createElement(RecentChangesFilterPanel, { onClickSearch: fetchdata }),
        React.createElement("div", { style: { marginInline: "20px" } },
            React.createElement(AonAgGridTable, { columns: columns(onHeaderClick, pageConfig.sortColumn, pageConfig.sortBy, isLoading), rowData: RecentChangesData, loading: isLoading, height: currentInneHeight - 230, rowStyle: getRowStyle }))));
}));
export default RecentChanges;
